import * as R from 'ramda';

// utils
import { SUPPLIER_AUTH_FILTERS } from '../../../../utils/constants';
import { AUTHORIZATION_TYPE } from '../../utils/const';

export const exchangeFilter = selection => item =>
  R.cond([
    [R.equals(SUPPLIER_AUTH_FILTERS.any), R.T],
    [R.equals(SUPPLIER_AUTH_FILTERS.turnedOn), () => !!item.exchange?.confirmed],
    [R.equals(SUPPLIER_AUTH_FILTERS.turnedOff), () => R.isNil(item.exchange)],
    [
      R.equals(SUPPLIER_AUTH_FILTERS.pendingAcceptance),
      () => R.pathEq(['exchange', 'confirmed'], false, item),
    ],
  ])(selection);

export const statusFilter = selection => item =>
  R.cond([
    [R.equals(SUPPLIER_AUTH_FILTERS.any), R.T],
    [R.equals(SUPPLIER_AUTH_FILTERS.turnedOn), () => item.active],
    [R.equals(SUPPLIER_AUTH_FILTERS.turnedOff), () => !item.active],
    [R.equals(SUPPLIER_AUTH_FILTERS.limitMet), () => item.limitMet],
  ])(selection);

export const typeFilter = selection => item =>
  R.cond([
    [R.equals(SUPPLIER_AUTH_FILTERS.any), R.T],
    [R.equals(SUPPLIER_AUTH_FILTERS.unlimited), () => item.unlimited],
    [
      R.equals(SUPPLIER_AUTH_FILTERS.monthly),
      () => item.limitType === R.toUpper(SUPPLIER_AUTH_FILTERS.monthly),
    ],
    [
      R.equals(SUPPLIER_AUTH_FILTERS.semiMonthly),
      () => item.limitType === AUTHORIZATION_TYPE.SEMIMONTH,
    ],
    [
      R.equals(SUPPLIER_AUTH_FILTERS.weekly),
      () => item.limitType === R.toUpper(SUPPLIER_AUTH_FILTERS.weekly),
    ],
    [
      R.equals(SUPPLIER_AUTH_FILTERS.daily),
      () => item.limitType === R.toUpper(SUPPLIER_AUTH_FILTERS.daily),
    ],
    [
      R.equals(SUPPLIER_AUTH_FILTERS.self),
      () => item.limitType === R.toUpper(SUPPLIER_AUTH_FILTERS.self),
    ],
  ])(selection);

export const filterBy =
  (selection, filterType, key = 'nameShort') =>
  item =>
    R.anyPass([R.equals(SUPPLIER_AUTH_FILTERS.any), R.equals(item[filterType][key])])(selection);
